import { render, staticRenderFns } from "./Impression.vue?vue&type=template&id=1c180dc1"
import script from "./Impression.vue?vue&type=script&lang=js"
export * from "./Impression.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports